import { StateControl } from "src/model/enum/enumControl";

export class Control {
    public id: number = 0;
    public idControlGroup: number = 0;
    public name: string = "";
    public description: string = "";
    public state: number = StateControl.Auto;
    public instanceGUIDStateAddress: string = "";
    public stateAddress: string = "";
    public onCommand: string = "";
    public offCommand: string = "";
    public priority: number = 1;

    public onAddCmd: string = "";
    public offAddCmd: string = "";

    constructor(controlType?: any) {
        // used for assign type to instance of object
        if (controlType) {
            Object.assign(this, controlType);
        }
    }
}